import {PokerInsuranceComponent} from '@interface/index';
import {getPokerBack, getPokerInsuranceImage} from '@utils/index';
import useCommon from '@utils/hooks/common';
import classNames from 'classnames';
import {useEffect, useState, useRef} from 'react';
import styles from './styles';

const FLIP_DELAY = 300;

const PokerInsurance = (props: PokerInsuranceComponent) => {
  const {
    suit,
    rank,
    className,
    cardClassName,
    state = 'NORMAL',
    isFlipped = true,
    cardSize,
  } = props;
  const {classes} = useCommon({
    withStyles: {styles, hasProps: true, props},
  });

  const getClassNamesOfCard = () => {
    return classNames({[classes.cardImage]: typeof cardClassName === 'undefined'}, cardClassName);
  };

  const getContainerClassName = () => {
    if (state === 'RAISED') {
      return classes.raised;
    }
    if (state === 'DARKEN') {
      return classes.darken;
    }
    return null;
  };

  return (
    // inline
    <article className={classNames(classes.cardContainer, className, getContainerClassName())}>
      <div className={classNames(classes.goldBorder, {show: state === 'RAISED'})}>
        <div
          className={classNames(classes.innerContainer, {
            flipped: isFlipped,
            [classes.small]: cardSize === 'small',
            [classes.medium]: cardSize === 'medium' || typeof cardSize === 'undefined',
            show: state === 'RAISED',
          })}
        >
          <img
            src={getPokerInsuranceImage({suit, rank})}
            alt=""
            className={classNames(getClassNamesOfCard(), classes.frontFace)}
          />
          <img
            src={getPokerBack()}
            alt=""
            className={classNames(getClassNamesOfCard(), classes.backFace)}
          />
        </div>
      </div>
    </article>
  );
};

export default PokerInsurance;
